import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import compose from 'recompose/compose';
import Header from 'components/ui/general/Header';
import InvitationsCreateForm from './InvitationsCreateForm';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { createInvitation } from 'store/actions/accounts/invitations/createInvitation';

const InvitationsCreateContainer = (props) => {
    const handleSubmitForm = (values) => {
        const {
            history,
            dispatchForm,
        } = props;

        return new Promise((resolve) => {
            dispatchForm({
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push('/current-account/invitations'));
                },
                values: values,
            });
        });
    };

    const {
        translate,
    } = props;

    const breadcrumbs = [
        {
            label: 'Invitations',
            link: '/current-account/invitations',
        },
        {
            label: translate('actions.create'),
        },
    ];

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ translate('resources.discounts.actions.create') } />

                <Actions>
                    <ListButton url='/current-account/invitations' />
                </Actions>
            </Header>

            <Card>
                <CardText>
                    <InvitationsCreateForm form='invitations-form' handleSubmitForm={ handleSubmitForm } />
                </CardText>
            </Card>
        </div>
    );

};

InvitationsCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createInvitation(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(InvitationsCreateContainer);


// WEBPACK FOOTER //
// ./src/pages/invitations/list/create/InvitationsCreateContainer.js